import dayjs from "dayjs";

export const transactionsTableColumns = [
  {
    title: "Fecha y hora",
    dataIndex: "created_at",
  },
  {
    title: "Estado",
    dataIndex: "state",
  },
  {
    title: "N° de recibo",
    dataIndex: "receipt_number",
  },
  {
    title: "Monto",
    dataIndex: "amount",
  },
  {
    title: "Moneda",
    dataIndex: "currency",
  },
  {
    title: "Método",
    dataIndex: "payment_method",
  },
  {
    title: "N° de la tarjeta",
    dataIndex: "card_number",
  },
  {
    title: "Nuevo saldo",
    dataIndex: "final_balance", 
  },
  {
    title: "Saldo previo",
    dataIndex: "initial_balance", 
  },
  // {
  //   title: "Descripción",
  //   dataIndex: "description",
  // },
  {
    title: "Descripción del producto",
    dataIndex: "product_description",
    width: 230,
  },
  {
    title: "Pagado por",
    dataIndex: ["created_by", "fullname"],
    width: 230,
    ellipsis: true,
  },
  {
    title: "Recibo",
    dataIndex: "receipt_download",
    fixed: "right",
  },
];

export const slotsTableColumns = [
  {
    title: "N°",
    customRender: ({ index }) => {
      return index + 1;
    },
    width: 60,
  },
  {
    title: "Slot",
    dataIndex: "user",
  },
  {
    title: "Nombre usuario asignado",
    key: "assign",
    dataIndex: ["user_data", "fullname"],
    width: 350,
  },
  {
    title: "Anexo",
    dataIndex: ["user_data", "annex_number"],
    customRender: ({ record }) => {
      if (record.user_data === null || record.user_data.annex_number === null) {
        return "-";
      }
    },
    width: 100,
  },
  {
    title: "Perfil",
    dataIndex: ["user_data", "profile"],
    customRender: ({ record }) => {
      if (record.user_data === null || record.user_data.profile === null) {
        return "-";
      }
    },
  },
  {
    title: "Estado de usuario",
    dataIndex: ["user_data", "user_status"],
    key: "status",
  },
  {
    title: "Acciones",
    dataIndex: "deleteSlot",
    width: 80,
  },
];

export const expensesTableColumns = [
  {
    title: "Fecha (UTC)",
    dataIndex: "date",
  },
  {
    title: "Alias del canal",
    dataIndex: ["channel_customer", "alias"],
    customRender: ({ text }) => text || "-",
    ellipsis: true,
    width: 180,
  },
  {
    title: "Identificador",
    dataIndex: ["channel_customer", "associate"],
    type: "info",
    info: "Teléfono asociado a tu empresa.",
  },
  {
    title: "Nombre oficial de Whatsapp",
    dataIndex: "app_name",
  },
  {
    title: "Estado",
    dataIndex: "status",
  },
  {
    title: "N° mensajes",
    dataIndex: "session_quantity",
    customRender: ({ text }) => text ?? 0,
    type: "info",
    info: "Total de mensajes enviados por la empresa o contacto, incluyendo los de plantilla.",
  },
  {
    title: "Consumo de fee",
    dataIndex: "total_session_price",
    type: "info",
    info: "Fee total consumido por tus mensajes. Al superar los $200, ¡tus mensajes están libres de fee hasta el próximo mes!",
    width: 180,
  },
  {
    title: "FEP",
    dataIndex: "fep_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "FEP: Free entry point. Estas son conversaciones que inician por un anuncio al que el cliente escribe.",
  },
  {
    title: "Service",
    dataIndex: "service_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "Todos los mensajes enviados por la empresa, excluyendo los de plantilla. Pueden ser de un asesor humano, chatbot o agente IA. ¡Gratis hasta los 1,000 mensajes por número de WhatsApp al mes!",
  },
  {
    title: "Marketing",
    dataIndex: "marketing_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "Mensajes de plantilla tipo Marketing enviados por la empresa (individuales o masivas).",
  },
  {
    title: "MM Lite",
    dataIndex: "marketing_lite_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "MM Lite: Marketing Messages Lite. Se indican los consumos por envío de mensajes del tipo Marketing Lite por WhatsApp.",
  },
  {
    title: "Authentication",
    dataIndex: "authentication_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "Mensajes de plantilla tipo Authentication enviadas por la empresa (individuales o masivas).",
  },
  {
    title: "Utility",
    dataIndex: "utility_quantity",
    customRender: ({ text }) => text ?? "-",
    type: "info",
    info: "Mensajes de plantilla tipo Utility enviadas por la empresa (individuales o masivas).",
  },
  {
    title: "Costo total",
    dataIndex: "total_price",
    type: "info",
    info: "Indica la suma del consumo de fee más el costo de las 4 categorías de mensajes según la tarifa del país al que se envían.",
    customRender: ({ text }) => `$${text}`,
  },
];

export const whatsappVoiceExpensesColumns = [
  {
    title: "Fecha (UTC)",
    dataIndex: "date",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  {
    title: "Alias del canal",
    dataIndex: "alias",
    customRender: ({ text }) => text || "-",
    ellipsis: true,
    width: 180,
  },
  {
    title: "Identificador",
    dataIndex: "identifier",
    type: "info",
    info: "Teléfono asociado a tu empresa.",
  },
  {
    title: "Nombre oficial de Whatsapp",
    dataIndex: "main_name", 
    customRender: ({ text }) => text || "-",
    ellipsis: true,
    width: 200,
  },
  {
    title: "Tiempo consumido",
    dataIndex: "total_minutes",
    type: "info",
    info: "Indica la cantidad de segundos consumidos transformado a un formato de horas.",
    customRender: ({ text }) => dayjs.duration(text * 60 * 1000).format("HH:mm:ss"),
  },
  {
    title: "Costo total",
    dataIndex: "total_price",
    type: "info",
    info: "Resultado del tiempo consumido multiplicado por el precio por segundo ($0,0003).",
    customRender: ({ text }) => `$${text ?? 0}`,
    fixed: "right",
  },
];

export const voiceExpensesColumns = [
  {
    title: "Fecha",
    dataIndex: "date",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  // {
  //   title: "Regla de marcación",
  //   dataIndex: ["dialing_rule", "name"],
  //   type: "info",
  //   info: "Nombre del destino otorgado desde el módulo de PBX.",
  // },
  {
    title: "Minutos consumidos",
    dataIndex: "total_minutes",
    type: "info",
    info: "El formato utilizado es de hh:mm:ss (horas:minutos:segundos)",
    customRender: ({ text }) => dayjs.duration(text * 60 * 1000).format("HH:mm:ss"),
  },
  {
    title: "N° de llamadas",
    dataIndex: "total_calls",
  },
  // {
  //   title: "Tiempo total en llamada",
  //   dataIndex: "total_call_time",
  //   customRender: ({ text }) => `${text} min`,
  // },
  {
    title: "Consumo total",
    dataIndex: "total",
    customRender: ({ text }) => `$${text ?? 0}`,
  },
];

export const smsExpensesColumns = [
  {
    title: "Fecha",
    dataIndex: "date",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  {
    title: "N° de mensajes enviados",
    dataIndex: "total_quantity",
    type: "info",
    info: "Un envío puede contener varios mensajes. El número de mensajes dependerá del número de caracteres de tu comunicación.",
  },
  {
    title: "Consumo total",
    dataIndex: "total_price",
    customRender: ({ text }) => `$${text}`,
  },
];

export const botAIExpensesColumns = [
  {
    title: "Fecha y hora",
    dataIndex: "date_interaction",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    title: "Nombre de Bot AI",
    dataIndex: "bot_name",
  },
  // {
  //   title: "Tokens In",
  //   dataIndex: "input_tokens",
    // type: "info",
    // info: "Tokens consumidos por el Agente IA al recibir mensajes."
  // },
  // {
  //   title: "Tokens Out",
  //   dataIndex: "output_tokens",
    // type: "info",
    // info: "Tokens consumidos por el Agente IA al enviar mensajes."
  // },
  {
    title: "Messages In",
    dataIndex: "messages_input",
    type: "info",
    info: "Cantidad de mensajes enviados al Agente IA."
  },
  {
    title: "Messages Out",
    dataIndex: "messages_output",
    type: "info",
    info: "Cantidad de mensajes que el Agente IA envió."
  },
  {
    title: "Fee",
    dataIndex: "fee",
    type: "info",
    info: "Costo por cada mensaje que envía o recibe el Agente IA."
  },
]

export const textToSpeechExpensesColumns = [
  {
    title: "Fecha y hora",
    dataIndex: "date",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    title: "Nombre de la estrategia de IVR",
    dataIndex: "name",
    width: 180,
  },
  {
    title: "Tipo de estrategia",
    dataIndex: "type_strategy_name",
  },
  {
    title: "N° de audios generados",
    dataIndex: "total_audios",
    type: "info",
    info: "El número de audios generados corresponde al mismo número de registros en la plantilla de la estrategia.",
  },
  {
    title: "N° de caracteres por audio",
    dataIndex: "character_audio",
    type: "info",
    info: "Las variables no se incluyen en el conteo de caracteres.",
    width: 140,
  },
  {
    title: "Costo por total de caracteres",
    dataIndex: "cost_character",
    type: "info",
    info: "Se calcula multiplicando el total de caracteres del texto por el costo por carácter ($0.000004).",
    customRender: ({ text }) => `$${text ?? 0}`,
    width: 140,
  },
  {
    title: "N° de variables",
    dataIndex: "count_variables",
    width: 140,
  },
  {
    title: "Costo por total de variables",
    dataIndex: "cost_variable",
    type: "info",
    info: "Se calcula multiplicando el total de variables del texto por el costo por variable ($0.0008).",
    customRender: ({ text }) => `$${text ?? 0}`,
    width: 140,
  },
  {
    title: "Consumo total",
    dataIndex: "total_price",
    type: "info",
    info: "Es la suma del costo total por caracteres más el costo total por variables, multiplicado por el número de registros en la plantilla de la estrategia.",
    customRender: ({ text }) => `$${text ?? 0}`,
  },
];